import {Component} from 'react'
import {AiFillHome, AiFillFire} from 'react-icons/ai'
import {SiYoutubegaming} from 'react-icons/si'
import {MdPlaylistAddCheck} from 'react-icons/md'

import CartContext from '../../context/CartContext'

import {
  SideBarContainer,
  NavItemsContainer,
  TextItemContainer,
  NavLink,
  ItemText,
  SideBarBottomContainer,
  BottomText,
  IconsContainer,
  IconImage,
} from './styledComponents'

class SideBar extends Component {
  renderStatusItem = () => (
    <CartContext.Consumer>
      {value => {
        const {isDarkTheme, activeTab, activeTabItem} = value

        const onClickHomeTabItem = () => {
          activeTabItem('HOME')
        }

        const onClickTrendingTabItem = () => {
          activeTabItem('TRENDING')
        }

        const onClickTGamingTabItem = () => {
          activeTabItem('GAMING')
        }

        const onClickSavedTabItem = () => {
          activeTabItem('SAVED VIDEOS')
        }

        const bgColor = isDarkTheme ? '#181818' : '#f9f9f9'
        const textColor = isDarkTheme ? '#f9f9f9' : '#181818'
        const activeTabBgColor = isDarkTheme ? '#2a2a2a' : '#e0e0e0'
        const activeTabColor = '#ff0000'
        const bottomContainerBgColor = isDarkTheme ? '#2a2a2a' : '#f1f5f9'
        const borderColor = isDarkTheme ? '#444' : '#e2e8f0'

        return (
          <SideBarContainer bgColor={bgColor}>
            <NavItemsContainer>
              <TextItemContainer
                isActive={
                  activeTab === 'HOME' ? activeTabBgColor : 'transparent'
                }
                onClick={onClickHomeTabItem}
              >
                <NavLink
                  to="/"
                  color={activeTab === 'HOME' ? activeTabColor : textColor}
                >
                  <AiFillHome />
                  <ItemText
                    color={activeTab === 'HOME' ? activeTabColor : textColor}
                  >
                    Home
                  </ItemText>
                </NavLink>
              </TextItemContainer>
              <TextItemContainer
                isActive={
                  activeTab === 'TRENDING' ? activeTabBgColor : 'transparent'
                }
                onClick={onClickTrendingTabItem}
              >
                <NavLink
                  to="/trending"
                  color={activeTab === 'TRENDING' ? activeTabColor : textColor}
                >
                  <AiFillFire />
                  <ItemText
                    color={
                      activeTab === 'TRENDING' ? activeTabColor : textColor
                    }
                  >
                    Trending
                  </ItemText>
                </NavLink>
              </TextItemContainer>
              <TextItemContainer
                isActive={
                  activeTab === 'GAMING' ? activeTabBgColor : 'transparent'
                }
                onClick={onClickTGamingTabItem}
              >
                <NavLink
                  to="/gaming"
                  color={activeTab === 'GAMING' ? activeTabColor : textColor}
                >
                  <SiYoutubegaming />
                  <ItemText
                    color={activeTab === 'GAMING' ? activeTabColor : textColor}
                  >
                    Gaming
                  </ItemText>
                </NavLink>
              </TextItemContainer>
              <TextItemContainer
                isActive={
                  activeTab === 'SAVED VIDEOS'
                    ? activeTabBgColor
                    : 'transparent'
                }
                onClick={onClickSavedTabItem}
              >
                <NavLink
                  to="/saved-videos"
                  color={
                    activeTab === 'SAVED VIDEOS' ? activeTabColor : textColor
                  }
                >
                  <MdPlaylistAddCheck />
                  <ItemText
                    color={
                      activeTab === 'SAVED VIDEOS' ? activeTabColor : textColor
                    }
                  >
                    Saved Videos
                  </ItemText>
                </NavLink>
              </TextItemContainer>
            </NavItemsContainer>
            <SideBarBottomContainer
              bgColor={bottomContainerBgColor}
              borderColor={borderColor}
            >
              <BottomText color={textColor}>CONTACT US</BottomText>
              <IconsContainer>
                <IconImage
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-facebook-logo-img.png"
                  alt="facebook logo"
                />
                <IconImage
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-twitter-logo-img.png"
                  alt="twitter logo"
                />
                <IconImage
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-linked-in-logo-img.png"
                  alt="linked in logo"
                />
              </IconsContainer>
              <ItemText color={textColor}>
                Enjoy! Now to see your channel and recommendation!
              </ItemText>
            </SideBarBottomContainer>
          </SideBarContainer>
        )
      }}
    </CartContext.Consumer>
  )

  render() {
    return <>{this.renderStatusItem()}</>
  }
}

export default SideBar
